import { CustomFieldFormType } from "../TreeView";
export const getFormTypeFromLevel = (level) => {
    switch (level) {
        case 1:
            return CustomFieldFormType.Section;
        case 2:
            return CustomFieldFormType.Subsection;
        case 3:
            return CustomFieldFormType.Field;
        default:
            return null;
    }
};
